import MotivationStats from './MotivationStats';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import StatusProgres from '../../progressbar/StatusProgres';
import './chaptercontainer.css';
import finishLesson from '../../imagesHome/finish_lesson.gif';
import '../../styles/darkmode.css';
import PracticeHelpPopup from './PracticeHelpPopup';
import final_congrats_conti from '../../imagesHome/final_congrats_conti.png';
import finishflag from '../../imagesHome/finish-flag.png';
import changecard from '../../imagesHome/change-card.png';
import Junphereconti from '../../imagesHome/Junphereconti.png';


import confettyFinish from '../../imagesHome/confettyFinish.gif';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faThumbsDown, faStar, faSquareCheck } from "@fortawesome/free-regular-svg-icons";
import { faCheckDouble, faCircleInfo, faGift } from "@fortawesome/free-solid-svg-icons";
import StreakDisplay from './StreakDisplay';



import { useCallback } from 'react';
import levelUp from '../../header/images/level-up.mp3';
import error from '../../header/images/error.mp3';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import CustomAlert from '../../progressbar/CustomAlert'; 
import FeedbackPopup from '../../popuplessons/FeedbackPopup';
import ExplanationPopup from '../../popuplessons/ExplanationPopup';

import fire from '../../imagesHome/fire.gif';
import NoLivesPopup from '../../progressbar/NoLivesPopup';

import Leaderboard from '../clasament/Leaderboard';
import finallessonprogress from '../../imagesHome/finallessonprogress.gif';













  // Adaugă URL-ul API-ului folosind variabila de mediu
  const apiUrl = process.env.REACT_APP_API_URL;

  // Adaugă această funcție pentru a iniția vibrația pe dispozitivele compatibile
const triggerVibration = (pattern) => {
  if (navigator.vibrate) {
    navigator.vibrate(pattern);
  }
};




const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};



const Chaptercontainer = () => {

const userId = localStorage.getItem("userId");

  const navigate = useNavigate();




  const [shuffledOptions, setShuffledOptions] = useState([]);
  const [shuffledMultipleOptions, setShuffledMultipleOptions] = useState([]);
  const [shuffledApplicationOptions, setShuffledApplicationOptions] = useState([]);
  const [shuffledDragOneOptions, setShuffledDragOneOptions] = useState([]);
  const [shuffledDragHorizontalOptions, setShuffledDragHorizontalOptions] = useState([]);
  const [shuffledDecisionOptions, setShuffledDecisionOptions] = useState([]);

  const [cardIndex, setCardIndex] = useState(0);
  const [leavingCardIndex, setLeavingCardIndex] = useState(null);
  const leaveCardTimerRef = useRef(null);












  const [lives, setLives] = useState(3);
  const [coinCount, setCoinCount] = useState(0);
  const [xp, setXp] = useState(0);
  const [correctStreak, setCorrectStreak] = useState(0);

// 🔥 statistici DOAR pentru lecția curentă
const [lessonCoins, setLessonCoins] = useState(0);
const [lessonXp, setLessonXp] = useState(0);
const [correctAnswersCount, setCorrectAnswersCount] = useState(0);
const [wrongAnswersCount, setWrongAnswersCount] = useState(0);

  

const [selectedRating, setSelectedRating] = useState(0);
const [showRatingMessage, setShowRatingMessage] = useState(false);
const [showRatingSection, setShowRatingSection] = useState(false);
const [decisionStepIndex, setDecisionStepIndex] = useState(0);
const [decisionAnswer, setDecisionAnswer] = useState(null);
const [decisionPhase, setDecisionPhase] = useState('intro');
// 'intro' | 'steps' | 'final'


const [showPracticeHelp, setShowPracticeHelp] = useState(false);


const ignoredForProgress = [
  'lessonResume',
  'JustInTimeMotivation',
  'serieCompleta',
  'deblocarePremium',
  'clasament',
  'lessonCompletion'
];





const handleRating = (value) => {
  setSelectedRating(value);

  // ascunde mesajul întâi
  setShowRatingMessage(false);

  // afișează după 0.2s
  setTimeout(() => {
    setShowRatingMessage(true);
  }, 200);

  handleFeedback(value);
};



    const location = useLocation();
  const { chapterId, lessonId, lessonData: lessonDataFromState } = location.state || {}; // Primește chapterId și lessonId
  const [lessonData, setLessonData] = useState(null);
  const [nextQuestion, setNextQuestion] = useState(0);
  const [showJumpHereIntro, setShowJumpHereIntro] = useState(false);


  
// 🔥 OPREȘTE LECȚIA CÂND VIEȚILE AJUNG LA 0
const [showNoLivesPopup, setShowNoLivesPopup] = useState(false);


useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];





  if (!currentQuestion) return;

  if (currentQuestion.type === 'simpleSelect') {
    setShuffledOptions(shuffleArray(currentQuestion.options));
    setShuffledMultipleOptions([]);
    setShuffledApplicationOptions([]);
    setShuffledDragOneOptions([]);
    setShuffledDragHorizontalOptions([]);
  }

  if (currentQuestion.type === 'multipleSelect') {
    setShuffledMultipleOptions(shuffleArray(currentQuestion.options));
    setShuffledOptions([]);
    setShuffledApplicationOptions([]);
    setShuffledDragOneOptions([]);
    setShuffledDragHorizontalOptions([]);
  }

  if (currentQuestion.type === 'simpleApplication') {
    setShuffledApplicationOptions(shuffleArray(currentQuestion.options));
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledDragOneOptions([]);
    setShuffledDragHorizontalOptions([]);
  }

  if (currentQuestion.type === 'dragAndDropOneAnswer') {
    setShuffledDragOneOptions(shuffleArray(currentQuestion.options));
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledApplicationOptions([]);
    setShuffledDragHorizontalOptions([]);
  }

  if (currentQuestion.type === 'dragAndDropHorizontal') {
    setShuffledDragHorizontalOptions(shuffleArray(currentQuestion.options));
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledApplicationOptions([]);
    setShuffledDragOneOptions([]);
  }
}, [lessonData, nextQuestion]);



useEffect(() => {
  setCardIndex(0);
  setLeavingCardIndex(null);
}, [nextQuestion]);


const updateCardIndexWithSwipe = useCallback((nextIndex) => {
  if (nextIndex === cardIndex) {
    return;
  }

  setLeavingCardIndex(cardIndex);

  if (leaveCardTimerRef.current) {
    clearTimeout(leaveCardTimerRef.current);
  }

  setCardIndex(nextIndex);

  leaveCardTimerRef.current = setTimeout(() => {
    setLeavingCardIndex(null);
    leaveCardTimerRef.current = null;
  }, 360);
}, [cardIndex]);


useEffect(() => {
  return () => {
    if (leaveCardTimerRef.current) {
      clearTimeout(leaveCardTimerRef.current);
    }
  };
}, []);



useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];

  if (!currentQuestion) return;
  if (currentQuestion.type !== 'decisionFlowApplication') return;

  const step = currentQuestion.steps?.[decisionStepIndex];
  if (!step) return;

  setShuffledDecisionOptions(shuffleArray(step.options));
}, [lessonData, nextQuestion, decisionStepIndex]);



useEffect(() => {
  const q = lessonData?.questions?.[nextQuestion];
  if (q?.type === 'decisionFlowApplication') {
    setDecisionPhase('intro');
    setDecisionStepIndex(0);
    setDecisionAnswer(null);
  }
}, [nextQuestion, lessonData]);



// 🔥 Resetăm viețile DOAR la începutul lecției, NU la fiecare update
useEffect(() => {
  if (nextQuestion === 0) {
    setLives(3);

    // 🔁 reset statistici pe lecție
    setLessonCoins(0);
    setLessonXp(0);
    setCorrectAnswersCount(0);
    setWrongAnswersCount(0);
  }
}, [nextQuestion]);

const isJumpHereLesson =
  (lessonDataFromState?.explanationType || lessonData?.explanationType || '')
    .toLowerCase() === 'jumphere';

useEffect(() => {
  if (isJumpHereLesson) {
    setShowJumpHereIntro(true);
    return;
  }

  setShowJumpHereIntro(false);
}, [isJumpHereLesson, chapterId, lessonId]);





useEffect(() => {
  const question = lessonData?.questions?.[nextQuestion];

  if (question?.type === 'dragAndDropHorizontal') {
    const blanksCount = question.correctAnswer.filter(
      (_, index) => index % 2 === 1
    ).length;

    setDataReceived(Array(blanksCount).fill(null));
  }
}, [lessonData, nextQuestion]);








useEffect(() => {
  if (lives <= 0) {
    setShowNoLivesPopup(true);
  }
}, [lives]);



useEffect(() => {
  if (!userId) return;

  fetch(`${apiUrl}/user/${userId}/stats`, {
    method: "GET",
    credentials: "include",
  })
    .then(res => res.json())
    .then(data => {
      setXp(data.xp || 0);
    })
    .catch(err => console.error("Eroare la preluarea XP:", err));
}, [userId]);


const addXp = async (amount) => {
  try {
    const res = await fetch(`${apiUrl}/stats/add-xp`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ xp: amount }),
    });

    if (!res.ok) throw new Error("Eroare la adăugarea XP");

    const data = await res.json();
    setXp(data.xp); // actualizezi XP din backend
  } catch (err) {
    console.error("Eroare update XP:", err);
  }
};


const addCoins = async (amount) => {
  try {
    const res = await fetch(`${apiUrl}/stats/add-coins`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ coins: amount }),
    });

    const data = await res.json();

    // 🔥 Actualizezi monedele și în UI
    setCoinCount(data.coins);

  } catch (err) {
    console.error("Eroare update coins:", err);
  }
};



const sendLessonFinishXp = async (amount) => {
  try {
    const res = await fetch(`${apiUrl}/stats/lesson-finished`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ xp: amount }),
    });

    const data = await res.json();
    setXp(data.xp);
  } catch (err) {
    console.error("Eroare la trimiterea XP final:", err);
  }
};




const grantXpForCorrectAnswer = () => {
  setCorrectStreak(prev => {
    const next = prev + 1;

    if (next === 5) {
      // bonus +20 XP
      addXp(20);
      setLessonXp(prevXp => prevXp + 20);
    } else {
      // normal +10 XP
      addXp(10);
      setLessonXp(prevXp => prevXp + 10);
    }

    // +1 întrebare corectă
    setCorrectAnswersCount(prevCorrect => prevCorrect + 1);

    return next;
  });
};



const handleXpResetOnWrongAnswer = () => {
  setCorrectStreak(0);
  setWrongAnswersCount(prev => prev + 1);
};


const handleCorrectCoins = () => {
  setCoinCount(prev => prev + 1);    // pentru bara din header
  setLessonCoins(prev => prev + 1);  // pentru statistica de lecție
};




useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];

  if (!currentQuestion) return;

  if (currentQuestion.type !== "lessonResume") {
    setShowRatingSection(false);
    return;
  }

  if (!currentQuestion.descriptionExplanation) return;

  // fiecare linie apare la 0.3s → totalul este:
  const delay = currentQuestion.descriptionExplanation.length * 300 + 400;

  const timer = setTimeout(() => {
    setShowRatingSection(true);
  }, delay);

  return () => clearTimeout(timer);
}, [lessonData, nextQuestion]);




useEffect(() => {
  if (showRatingSection) {
    const el = document.querySelector('.explanation-lesoon-container-resume-bc');

    if (el) {
      el.classList.add('no-scroll-transition');

      setTimeout(() => {
        el.classList.remove('no-scroll-transition');
      }, 600); // puțin peste durata animatiei
    }
  }
}, [showRatingSection]);




  useEffect(() => {
  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = '';
  };

  window.addEventListener('beforeunload', handleBeforeUnload);

  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
}, []);



const noTransitionTypes = [ 
  'lessonResume',
  'JustInTimeMotivation',
  'serieCompleta',
  'deblocarePremium',
  'clasament',
  'lessonCompletion',
  'giftlesson'
];




useEffect(() => {
  document.documentElement.classList.add("quiz-active");
  document.body.classList.add("quiz-active");

  return () => {
    document.documentElement.classList.remove("quiz-active");
    document.body.classList.remove("quiz-active");
  };
}, []);



  const [hideActionButton, setHideActionButton] = useState(false);

const [showComments, setShowComments] = useState(false);



const [showExplanationPopupModal, setShowExplanationPopupModal] = useState(false);




const sendLessonCompletion = async (questionType) => {
  if (questionType !== 'lessonCompletion') {
    return;
  }

  const normalizedChapterId = Number(chapterId);
  const normalizedLessonId = Number(lessonId);

  if (!Number.isFinite(normalizedChapterId) || !Number.isFinite(normalizedLessonId)) {
    console.error('❌ ID-uri invalide pentru lesson completion:', { chapterId, lessonId });
    return;
  }

  try {
    const response = await fetch(`${apiUrl}/lesson/complete`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        chapterId: normalizedChapterId,
        lessonId: normalizedLessonId
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}`);
    }

    console.log("✅ Lesson completion trimisa");
  } catch (err) {
    console.error("❌ Eroare lesson completion:", err);
  }
};


  
  
  const [showFeedback, setShowFeedback] = useState(false);

const handleShowFeedback = () => setShowFeedback(true);
const handleHideFeedback = () => setShowFeedback(false);


  const explanationRef = useRef(null);




const updateCoins = (newAmount) => {
  fetch(`${apiUrl}/user/${userId}/stats`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      coins: newAmount
    })
  })
  .catch(err => console.log("Error updating coins:", err));
};








  const [showExplanationPopup, setShowExplanationPopup] = useState(false);




  const [showEyePopup, setShowEyePopup] = useState(false);

const handleShowEyePopup = () => {
  setShowEyePopup(true);
};

const closeEyePopup = () => {
  setShowEyePopup(false);
};



const [showAlert, setShowAlert] = useState(false);


const handleExitClick = () => {
  setShowAlert(true);
};

const handleConfirmExit = () => {
  setShowAlert(false);
  navigate('/functionalpagelogin'); // Redirecționează către pagina /functionalpagelogin
};

const handleCancelExit = () => {
  setShowAlert(false);
};

const messageAlertClose = 
<div>
  <h3>Nu renunța!</h3>
  <p>Dacă părăsești această lecție, vei pierde progresul. Ești sigur?</p>
</div>;








  const currentType = lessonData?.questions?.[nextQuestion]?.type;




  const [isLessonFinished, setIsLessonFinished] = useState(false); // Stare pentru finalizarea lecției


  const [changeColorButton, setChangeColorButton] = useState(false);




  //stateuri pentru raspunsul corect

  const [simpleCorrectAnswer, setSimpleCorrectAnswer] = useState(false)


const lessonCompletionSentRef = useRef(false);



  // Funcția pentru a finaliza lecția și redirecționare

  
  const finalizeLesson = () => {

    const lessonProgress = JSON.parse(localStorage.getItem('lessonProgress')) || {};
    const normalizedChapterId = Number(chapterId);
    const normalizedLessonId = Number(lessonId);
    const currentLessonKey = `${normalizedChapterId}-${normalizedLessonId}`;

    const updatedProgress = {
      [currentLessonKey]: {
        ...(lessonProgress[currentLessonKey] || {}),
        completed: true,
        unlocked: true,
      },
    };

    // Salvează progresul actualizat în localStorage
    localStorage.setItem(
      'lessonProgress',
      JSON.stringify({
        ...lessonProgress,
        ...updatedProgress,
      })
    );
    addXp(20);


    // Navighează înapoi la Showlessons și trimite progresul prin state
    navigate('/functionalpagelogin', { state: { updatedProgress } });
 // Redirecționează la LessonContainer
  };

  

//functia pentru calcularea progresului

const calculateProgress = () => {
  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return 0;
  }

  const questions = lessonData.questions;

  // 👉 doar cele care contează la progres (fără clasament, lessonResume etc.)
  const countedQuestions = questions.filter(
    q => !ignoredForProgress.includes(q.type)
  );

  // dacă nu avem întrebări „reale”, progres 0
  if (countedQuestions.length === 0) return 0;

  const currentQuestion = questions[nextQuestion];
  const nextQuestionType = questions[nextQuestion + 1]?.type;
  const isCurrentQuestionCounted =
    currentQuestion && !ignoredForProgress.includes(currentQuestion.type);

  const isDecisionFlowInProgress =
    currentQuestion?.type === 'decisionFlowApplication' &&
    decisionPhase !== 'final';

  const shouldPreviewCompletionProgress =
    !isDecisionFlowInProgress && (
      pendingLessonCompletionAdvance || (
      nextQuestionType === 'lessonCompletion' ||
      nextQuestionType === 'giftlesson' ||
      nextQuestion + 1 >= questions.length
    ) &&
    (isAnswerChecked || !isCurrentQuestionCounted)
  );

  const effectiveQuestionIndex = shouldPreviewCompletionProgress
    ? nextQuestion + 1
    : nextQuestion;

  // câte întrebări „reale” ai trecut până la indexul efectiv
  const doneCount = questions
    .slice(0, effectiveQuestionIndex)
    .filter(q => !ignoredForProgress.includes(q.type))
    .length;

  const totalCount = countedQuestions.length;
  const progress = (doneCount / totalCount) * 100;

  return Math.min(progress, 100);
};








  //state pentru setarea mesajului

    // State pentru a stoca răspunsurile mutate
    const [dataReceived, setDataReceived] = useState([]);
    const [isTopProgressReady, setIsTopProgressReady] = useState(true);
    const [pendingLessonCompletionAdvance, setPendingLessonCompletionAdvance] = useState(false);
    const [shouldDelayLessonCompletionAdvance, setShouldDelayLessonCompletionAdvance] = useState(false);
    const lessonCompletionDelayTimeoutRef = useRef(null);

 


     
 


const advanceQuestion = () => {
  resetQuestionState();

  setNextQuestion((prev) => {
    const newNextQuestion = prev + 1;

    // Dacă am ajuns la ultima întrebare → marchează lecția ca finalizată
    if (newNextQuestion >= lessonData.questions.length) {
      setIsLessonFinished(true);
      // finalMessage will be set with delay in useEffect
      return prev; // ✅ rămâne pe ultima întrebare, nu trece peste array
    }

    return newNextQuestion;
  });
};

const toNextQuestion = () => {
  if (pendingLessonCompletionAdvance) {
    return;
  }

  if (!noTransitionTypes.includes(currentType) && !isTopProgressReady) {
    return;
  }

  const nextQuestionType = lessonData?.questions?.[nextQuestion + 1]?.type;
  const shouldWaitForCompletionBar =
    nextQuestionType === 'lessonCompletion' ||
    nextQuestionType === 'giftlesson';

  if (shouldWaitForCompletionBar && !pendingLessonCompletionAdvance) {
    setIsTopProgressReady(true);
    setShouldDelayLessonCompletionAdvance(false);
    setPendingLessonCompletionAdvance(false);
    advanceQuestion();
    return;
  }

  advanceQuestion();
};

useEffect(() => {
  if (!pendingLessonCompletionAdvance || !isTopProgressReady) {
    return;
  }

  if (shouldDelayLessonCompletionAdvance) {
    if (lessonCompletionDelayTimeoutRef.current) {
      clearTimeout(lessonCompletionDelayTimeoutRef.current);
    }

    lessonCompletionDelayTimeoutRef.current = setTimeout(() => {
      setPendingLessonCompletionAdvance(false);
      setShouldDelayLessonCompletionAdvance(false);
      advanceQuestion();
      lessonCompletionDelayTimeoutRef.current = null;
    }, 0);

    return;
  }

  setPendingLessonCompletionAdvance(false);
  setShouldDelayLessonCompletionAdvance(false);
  advanceQuestion();
}, [pendingLessonCompletionAdvance, isTopProgressReady, shouldDelayLessonCompletionAdvance]);

useEffect(() => {
  if (!pendingLessonCompletionAdvance || isTopProgressReady) {
    return;
  }

  const fallbackTimer = setTimeout(() => {
    setIsTopProgressReady(true);
  }, 700);

  return () => clearTimeout(fallbackTimer);
}, [pendingLessonCompletionAdvance, isTopProgressReady]);

useEffect(() => {
  return () => {
    if (lessonCompletionDelayTimeoutRef.current) {
      clearTimeout(lessonCompletionDelayTimeoutRef.current);
    }
  };
}, []);




useEffect(() => {
  if (!lessonData) return;

  const question = lessonData.questions[nextQuestion];

  if (!question) return;

  // 🔥 reset total pentru drag & drop
  if (question.type === 'dragAndDropHorizontal') {
    const blanksCount = question.correctAnswer.filter(
      (_, index) => index % 2 === 1
    ).length;

    setDataReceived(Array(blanksCount).fill(null));
  }

  if (question.type === 'dragAndDropOneAnswer') {
    setDataReceived([]); // 🔥 FOARTE IMPORTANT
  }
}, [nextQuestion, lessonData]);



useEffect(() => {
  if (explanationRef.current) {
    explanationRef.current.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } else {
    // fallback pentru tot documentul dacă nu ai explanationRef în pagină
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}, [nextQuestion]);




  useEffect(() => {
    if (chapterId && lessonId) {
      // Cererea fetch pentru lecția selectată
      fetch(`${apiUrl}/chapter/${chapterId}/lesson/${lessonId}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache"
        }
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error('A apărut o eroare');
        }
        return response.json();
      })
      .then(data => {
        setLessonData(data);
      })
      .catch(err => {
        console.error(`Error: ${err}`);
      });
    }
  }, [chapterId, lessonId]);


// Folosim un string (sau null) pentru simpleSelectType, deoarece utilizatorul selectează o singură opțiune
const [simpleSelectType, setSimpleSelectType] = useState(null); //usestateul pentru stocarea raspusurilor simple select
const [userInput, setUserInput] = useState({});  // Răspunsul introdus de utilizator
const [selectedAnswers, setSelectedAnswers] = useState([]); // Răspunsurile bifate de utilizator
const [message, setMessage] = useState('');
const [textButton, setTextButton] = useState('')

useEffect(() => {
  setTextButton('Continua');
}, [isLessonFinished, lessonData, nextQuestion]);


const [isAnswerChecked, setIsAnswerChecked] = useState(false); //urmaresc daca raspunsul a fost verificat


const buttonTextChange = () => {

  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return <p>Loading lesson...</p>;
  }
  const currentQuestion = lessonData.questions[nextQuestion]; 

  switch (currentQuestion.type) {
 

    case 'simpleSelect':
      setTextButton('Verifica')
      setChangeColorButton(true)
      break;

    case 'manualInput':
      
      break;

 

      case 'dragAndDropHorizontal':
        setTextButton('Verifica');
       
        
        break;

        case 'dragAndDropOneAnswer':
          setTextButton('Verifica');
         
          
          break;


    case 'multipleSelect':
      setTextButton('Verifica')
     
      break;

    default:
      
  }
};


const [desableButon, setDesableButton] = useState(false);
//functia pentru dezactivarea butonului






useEffect(() => {
  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
      return;
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  // Resetare stări pentru fiecare nouă întrebare
  setIsAnswerChecked(false);
  setSimpleSelectType(null);
  setMessage('');
  setSimpleCorrectAnswer(false);  // Ascunde răspunsul corect

  // Dacă tipul întrebării necesită selecție, dezactivează butonul
  if (['simpleSelect', 'manualInput', 'dragAndDropHorizontal', 'dragAndDropOneAnswer', 'multipleSelect'].includes(currentQuestion.type)) {
      setDesableButton(true);
  } else {
      // Activați butonul pentru explanationLesson și lessonResume
      setDesableButton(false);
  }
}, [nextQuestion, lessonData]);


const [answerStatus, setAnswerStatus] = useState(null); // Starea pentru corect/greșit/null


const resetQuestionState = () => {
  setSelectedAnswers([]);
  setSimpleSelectType(null);
  setUserInput({});
  setIsAnswerChecked(false);
  setSimpleCorrectAnswer(false);
  setAnswerStatus(null);
  setMessage('');
  setTextButton('');
  setChangeColorButton(false);
  setDesableButton(true);
  setShowCorrectAnswer(false);
};












// Adăugăm o stare pentru a controla afișarea răspunsului corect
const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);




  //functia de verificare a raspunsurilor
  
  const verifyAnswer = () => {

       if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
      return <p>Loading lesson...</p>;
    }
    const currentQuestion = lessonData.questions[nextQuestion]; 


    switch (currentQuestion.type) {
 

      case 'simpleSelect':
          if (!isAnswerChecked) {
              setDesableButton(true); // Dezactivați butonul la începutul întrebării
              if (currentQuestion.correctAnswer === simpleSelectType) {
                setMessage(''); // Folosește numele real al array-ului

                  setAnswerStatus('correct');
                  const audioUp = new Audio(levelUp);
                  audioUp.play();
                  handleCorrectCoins();

                 // -------- XP ----------
                 grantXpForCorrectAnswer();




                  triggerVibration(200);
                  setDesableButton(false); // Activează butonul după verificarea răspunsului
              } else {
                  setMessage(''); 
                  setAnswerStatus('incorrect');
                  // 🔥 Scadem o viață când răspunsul este greșit
setLives(prev => prev - 1);
handleXpResetOnWrongAnswer();





                  const audioErr = new Audio(error);
                  audioErr.play();
                  setSimpleCorrectAnswer(currentQuestion.correctAnswer);
                  triggerVibration([300, 100, 300]);
                  setDesableButton(false);
              }
              setIsAnswerChecked(true);
             
              setShowCorrectAnswer(false);
              setChangeColorButton(false);
          } else {
              // Trecem la următoarea întrebare
              setIsAnswerChecked(false);
              setSimpleSelectType(null);
              setMessage('');
              
              toNextQuestion();
              setShowCorrectAnswer(false);
          }
          break;
      case 'manualInput':
        if (!isAnswerChecked) {
          // Verificăm dacă toate răspunsurile sunt corecte
          let allCorrect = true;
          currentQuestion.correctAnswer.forEach((answer, index) => {
            // Comparam răspunsul utilizatorului cu codul corect
            if (Number(userInput[index]) !== answer.code) {
              allCorrect = false;
            }
          });
          if (allCorrect) {
           setMessage('');
            setAnswerStatus('correct');
            const audioUp = new Audio(levelUp);
                audioUp.play();
            setSimpleCorrectAnswer(false);
            handleCorrectCoins();

                 grantXpForCorrectAnswer();



            // Vibrație scurtă pentru răspuns corect
          triggerVibration(200); // 200ms pentru un răspuns corect
          } else {
            setMessage('');

            setAnswerStatus('incorrect');
            // 🔥 Scadem o viață când răspunsul este greșit
setLives(prev => prev - 1);
handleXpResetOnWrongAnswer();





            const audioErr = new Audio(error);
            audioErr.play();
            setSimpleCorrectAnswer(currentQuestion.correctAnswer.map((newAnswer) => {
             return <div>{newAnswer.code}:{newAnswer.label}</div>
            }));
            triggerVibration([300, 100, 300]);
          }
          setIsAnswerChecked(true);  // Marchez răspunsul ca verificat
          setChangeColorButton(false)
          setDesableButton(false); // Activăm butonul după verificare pentru a permite utilizatorului să continue
        } else {
          // A doua fază: Trecem la următoarea întrebare
          setIsAnswerChecked(false);  // Resetează starea de verificare
          setUserInput({});  // Resetează input-urile utilizatorului
          setMessage('');  // Resetează mesajul
          setChangeColorButton(false);
          toNextQuestion();  // Trecem la următoarea întrebare
        }
        break;
   

case 'simpleApplication':
  if (!isAnswerChecked) {
    if (currentQuestion.correctAnswer === simpleSelectType) {
      setAnswerStatus('correct');
      const audioUp = new Audio(levelUp);
      audioUp.play();
      handleCorrectCoins();

                grantXpForCorrectAnswer();



      triggerVibration(200);
    } else {
      setAnswerStatus('incorrect');
      // 🔥 Scadem o viață când răspunsul este greșit
setLives(prev => prev - 1);
handleXpResetOnWrongAnswer();





      const audioErr = new Audio(error);
      audioErr.play();
      setSimpleCorrectAnswer(currentQuestion.correctAnswer);
      triggerVibration([300, 100, 300]);
    }

    setIsAnswerChecked(true);
    setChangeColorButton(false);
  } else {
    setIsAnswerChecked(false);
    setSimpleSelectType(null);
    setMessage('');
    toNextQuestion();
  }
  break;


case 'decisionFlowApplication': {
  const step = currentQuestion.steps[decisionStepIndex];

  if (decisionAnswer === step.correctAnswer) {
    setAnswerStatus('correct');
    handleCorrectCoins();
    grantXpForCorrectAnswer();
    new Audio(levelUp).play();
    triggerVibration(200);
  } else {
    setAnswerStatus('incorrect');
    setLives(prev => prev - 1);
    handleXpResetOnWrongAnswer();
    new Audio(error).play();
    triggerVibration([300, 100, 300]);
  }

  setIsAnswerChecked(true);
  break;
}





case 'dragAndDropHorizontal': {
  if (!isAnswerChecked) {
    const expected = currentQuestion.correctAnswer.filter(
      (_, index) => index % 2 === 1
    );

    const userAnswers = dataReceived.filter(
      v => v !== null && v !== undefined
    );

    const isCorrect =
      userAnswers.length === expected.length &&
      userAnswers.every((value, index) => value === expected[index]);

    if (isCorrect) {
      setAnswerStatus('correct');
      handleCorrectCoins();
      grantXpForCorrectAnswer();
      new Audio(levelUp).play();
      triggerVibration(200);
    } else {
      setAnswerStatus('incorrect');
      setLives(prev => prev - 1);
      handleXpResetOnWrongAnswer();
      setSimpleCorrectAnswer(expected);
      new Audio(error).play();
      triggerVibration([300, 100, 300]);
    }

    setIsAnswerChecked(true);
    setChangeColorButton(false);
  } else {
    const blanksCount = currentQuestion.correctAnswer.filter(
      (_, index) => index % 2 === 1
    ).length;

    setDataReceived(Array(blanksCount).fill(null));
    setIsAnswerChecked(false);
    setChangeColorButton(false);
    toNextQuestion();
  }
  break;
}

    case 'dragAndDropOneAnswer':
  if (!isAnswerChecked) {
    const userAnswer = dataReceived[0];
    const correctAnswer = currentQuestion.correctAnswer[1]; 
    

    if (userAnswer === correctAnswer) {
      setMessage('');
      setTextButton('Verifica');
      const audioUp = new Audio(levelUp);
      audioUp.play();
     handleCorrectCoins();

             grantXpForCorrectAnswer();



      triggerVibration(200);
      setAnswerStatus('correct');
      setSimpleCorrectAnswer(false);
    } else {
      setMessage('');
      setTextButton('Verifica');
      const audioErr = new Audio(error);
      audioErr.play();
      setSimpleCorrectAnswer(<div>{correctAnswer}</div>);
      triggerVibration([300, 100, 300]);
      setAnswerStatus('incorrect');
      // 🔥 Scadem o viață când răspunsul este greșit
setLives(prev => prev - 1);
handleXpResetOnWrongAnswer();





    }

    setIsAnswerChecked(true);
    setChangeColorButton(false);
  } else {
    // când trecem la întrebarea următoare
    setIsAnswerChecked(false);
    setDataReceived([]); // un singur element, deci reset total
    setMessage('');
    setTextButton('Verifica');
    setChangeColorButton(true); // ✅ să redevină colorat pentru starea de verificare
    toNextQuestion();
  }
  break;




        
      case 'multipleSelect':
        if (!isAnswerChecked) {
          // Verificăm dacă răspunsurile selectate de utilizator sunt corecte
          const sortedSelected = [...selectedAnswers].sort();  // Sortăm o copie pentru comparație
          const sortedCorrect = [...currentQuestion.correctAnswer].sort();  // Sortăm răspunsurile corecte
          
          if (JSON.stringify(sortedSelected) === JSON.stringify(sortedCorrect)) {
           setMessage('');
            setAnswerStatus('correct');
            const audioUp = new Audio(levelUp);
                audioUp.play();
            setSimpleCorrectAnswer(false);
           handleCorrectCoins();

             grantXpForCorrectAnswer();


            triggerVibration(200);
          } else {
            setMessage('');
            setAnswerStatus('incorrect');
            // 🔥 Scadem o viață când răspunsul este greșit
setLives(prev => prev - 1);
handleXpResetOnWrongAnswer();





            const audioErr = new Audio(error);
                audioErr.play();
            setSimpleCorrectAnswer(currentQuestion.correctAnswer);
            triggerVibration([300, 100, 300]);
          }
          setIsAnswerChecked(true);  // Marchez răspunsul ca verificat
        
          setChangeColorButton(false);
        } else {
          // A doua fază: Trecem la următoarea întrebare
          setIsAnswerChecked(false);  // Resetează starea de verificare
          setSelectedAnswers([]);  // Resetează răspunsurile selectate
          setMessage('');  // Resetează mesajul
      
          setChangeColorButton(false);
          toNextQuestion();  // Trecem la următoarea întrebare
        }
        break;
        case 'lessonResume':



      
         
          setIsLessonFinished(true)
        
        break;
      default:
       <p>'Tipul întrebării nu este recunoscut'</p> 
    }
  };
  

  const handleInputChange = (index, value) => {
    const updatedInput = {
      ...userInput,
      [index]: value  // Actualizăm răspunsul pentru fiecare index
    };
    
    setUserInput(updatedInput);

   
  
    // Verificăm dacă s-au introdus date în cel puțin un câmp de input
    const hasData = Object.values(updatedInput).some(val => val.trim() !== '');
    
    // Schimbăm textul butonului dacă există input
    if (hasData) {
      setTextButton('Verifica');
    
      setChangeColorButton(true);
    } else {
      setTextButton('Continua');
    }
  };
 



// Funcția pentru a actualiza răspunsurile selectate
const handleCheckboxChange = (option) => {
  setSelectedAnswers(prevSelected => {
    let updatedSelected;
    
    if (prevSelected.includes(option)) {
      // Dacă opțiunea este deja selectată, o eliminăm din array
      updatedSelected = prevSelected.filter(answer => answer !== option);
    } else {
      // Adăugăm opțiunea selectată
      updatedSelected = [...prevSelected, option];
    }
    
    // Verificăm dacă mai sunt opțiuni selectate
    setDesableButton(updatedSelected.length === 0); // Dezactivează butonul dacă nu e nimic selectat
    return updatedSelected; // Returnează lista actualizată de răspunsuri selectate
  });

  // După fiecare schimbare, setăm textul butonului la "Verifică"
  setTextButton('Verifica');
 
  setChangeColorButton(true);
};

const [finalMessage, setFinalMessage] = useState(false);
const [isLessonCompletionBarDone, setIsLessonCompletionBarDone] = useState(false);

useEffect(() => {
  const activeQuestionType = lessonData?.questions?.[nextQuestion]?.type;

  if (activeQuestionType === 'lessonCompletion') {
    setIsLessonCompletionBarDone(false);
  }
}, [lessonData, nextQuestion]);

useEffect(() => {
  if (isLessonFinished) {
    finalizeLesson();
  }
}, [isLessonFinished]);


const [showFinalTitle, setShowFinalTitle] = useState(false);

useEffect(() => {
  if (finalMessage) {
    setShowFinalTitle(false); // resetăm înainte
    const timer = setTimeout(() => {
      setShowFinalTitle(true);  // apare cu întârziere
    }, 2500);

    return () => clearTimeout(timer);
  }
}, [finalMessage]);


const [successBubbleText, setSuccessBubbleText] = useState('Felicitari!');
const [successBubblePhase, setSuccessBubblePhase] = useState('initial'); // 'initial' | 'transition' | 'final'

useEffect(() => {
  // Resetează textul când se finalizează lecția
  if (isLessonFinished) {
    setSuccessBubbleText('Felicitari!');
    setSuccessBubblePhase('initial');
    
    // După 1.5 secunde, schimbă textul cu animație
    const timer = setTimeout(() => {
      setSuccessBubblePhase('transition');
      
      // Schimbă textul după ce animația de ieșire s-a terminat
      setTimeout(() => {
        setSuccessBubbleText('Ai terminat cu succes lectia');
        setSuccessBubblePhase('initial'); // Reset la initial pentru a putea aplica slideInRight
      }, 600); // Timing complet cu slide-out animation (0.6s)
      
      // Schimbă la 'final' pentru a porni slideInRight
      setTimeout(() => {
        setSuccessBubblePhase('final');
      }, 610); // Puțin după ce textul s-a schimbat
    }, 1500);

    return () => clearTimeout(timer);
  }
}, [isLessonFinished]);



const areAllFieldsCompleted = useCallback(() => {
  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return false;
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  if (!currentQuestion) return false;

  switch (currentQuestion.type) {
    
    case 'dragAndDropHorizontal':
      return dataReceived.every(val => val !== null && val !== undefined);
    case 'dragAndDropOneAnswer':
      return dataReceived.length === 1 && dataReceived[0] !== null && dataReceived[0] !== undefined;
    default:
      return true;
  }
  
}, [lessonData, nextQuestion, dataReceived]);


const handleFeedback = (type) => {
  if (type === 'like') {
    console.log("Utilizatorul a apreciat lecția.");
    // poți trimite către un API, localStorage etc.
  } else {
    console.log("Utilizatorul nu a fost mulțumit.");
  }

  // opțional: afișează un mesaj de mulțumire sau închide feedbackul
};








useEffect(() => {
  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return;
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  switch (currentQuestion.type) {
    case 'simpleSelect':
      // Dezactivăm butonul dacă nu s-a selectat încă un răspuns
      setDesableButton(simpleSelectType === null);
      break;

    case 'multipleSelect':
      // Dezactivăm butonul dacă nu s-a selectat încă un răspuns
      setDesableButton(selectedAnswers.length === 0);
      break;


      case 'simpleApplication':
  setDesableButton(simpleSelectType === null);
  break;


  case 'decisionFlowApplication':
  if (decisionPhase === 'steps') {
    setDesableButton(decisionAnswer === null);
  } else {
    setDesableButton(false);
  }
  break;


    case 'manualInput':
      // Verificăm dacă toate câmpurile de input sunt completate
      const allFilled = currentQuestion.correctAnswer.every((_, idx) => {
        return userInput[idx] && userInput[idx].trim() !== '';
      });
      setDesableButton(!allFilled);
      break;



      case 'dragAndDropHorizontal':
      // Verificăm dacă toate elementele au fost mutate corect
      setDesableButton(!areAllFieldsCompleted());
      break;
case 'dragAndDropOneAnswer': {
  const isSelected = dataReceived.length === 1 && dataReceived[0] !== null && dataReceived[0] !== undefined;
  setDesableButton(!isSelected);
  break;
}





    default:
      // Activăm butonul pentru explanationLesson și lessonResume
      setDesableButton(false);
      break;
  }
}, [simpleSelectType, selectedAnswers, userInput, dataReceived, nextQuestion, lessonData, areAllFieldsCompleted]);








const renderContent = () => {
  // dacă am trecut de ultima întrebare, nu mai randăm conținut de întrebare
  if (!lessonData || !lessonData.questions) return null;
  if (nextQuestion >= lessonData.questions.length) return null;

  if (isLessonFinished && finalMessage) {
    return null; // ascunde conținutul lecției când e final
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  
   
    switch (currentQuestion.type) {

    case 'explanationLesson':
      return (
        <div className="quiz-content-scroll-bc">
          <div ref={explanationRef}>
            <div className="description-lesson-text-explanation-bc">
              {/* Show card-dots only if more than one paragraph */}
              {currentQuestion?.type === 'explanationLesson' &&
                Array.isArray(currentQuestion.descriptionExplanation) &&
                currentQuestion.descriptionExplanation.length > 1 && (
                  <div className="card-dots">
                    {currentQuestion.descriptionExplanation.map((_, i) => (
                      <span
                        key={i}
                        className={`dot ${i === cardIndex ? 'active' : ''}`}
                        onClick={() => updateCardIndexWithSwipe(i)}
                      />
                    ))}
                  </div>
                )}

              {/* CARDURI CONTROLATE */}
              <div className="card-stack-container">
                {currentQuestion.descriptionExplanation.map((explanation, index) => {
                  const totalCards = currentQuestion.descriptionExplanation.length;
                  const offset = (index - cardIndex + totalCards) % totalCards;
                  const isLeavingCard = index === leavingCardIndex;

                  // 🔥 cardul curent + următorul (circular) + cardul care iese spre dreapta
                  if (offset > 1 && !isLeavingCard) return null;

                  const cardStateClass = isLeavingCard
                    ? 'leaving'
                    : offset === 0
                    ? 'active'
                    : 'next';

                  return (
                    <div
                      key={index}
                      className={`explanation-card-bc ${cardStateClass}`}
                      style={{
                        transform:
                          isLeavingCard
                            ? 'translateX(120%) rotate(7deg) scale(0.93)'
                            : offset === 0
                            ? 'translateY(0) scale(0.95)'
                            : 'translateY(0px) translateX(0px) scale(0.96) rotate(2deg)',
                        zIndex: isLeavingCard ? 12 : 10 - offset,
                        opacity: isLeavingCard ? 0 : offset === 0 ? 1 : 0.5
                      }}
                    >
                      <div
                        className="text-size-emplanation-bc"
                        dangerouslySetInnerHTML={{ __html: explanation }}
                      />
                    </div>
                  );
                })}
              </div>

              {/* IMAGINE doar sub ultimul card */}
              {currentQuestion.image && (
                <div className="lesson-image-container">
                  <img
                    src={currentQuestion.image}
                    alt="Explicatie lectie"
                    className="lesson-image"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      );

    case 'giftlesson':
      return (
        <div className="quiz-content-scroll-bc">
          <div className="gift-lesson-container">
            <div className="gift-lesson-header">
              <h2>🎁 Felicitări! Ai primit un cadou!</h2>
            </div>
            <div className="gift-lesson-content">
              {Array.isArray(currentQuestion.giftMessages)
                ? currentQuestion.giftMessages.map((msg, idx) => (
                    <div key={idx} className="gift-message" dangerouslySetInnerHTML={{ __html: msg }} />
                  ))
                : <div className="gift-message" dangerouslySetInnerHTML={{ __html: currentQuestion.giftMessages }} />}
            </div>
            {currentQuestion.giftImage && (
              <div className="gift-lesson-image-container">
                <img
                  src={currentQuestion.giftImage}
                  alt="Gift"
                  className="gift-lesson-image"
                />
              </div>
            )}
       
          </div>
        </div>
      );


      case 'simpleSelect':
        return (
          <div className="quiz-content-scroll-bc">
          <div className='explanation-lesoon-container-bc'>
           
            <div className='tittle-sescrition-lesson title-simple-select-align'>

            <div className="centred-simple-element">
              <span className="question-text-bc">{currentQuestion.question}</span>
             
            </div>

              

            </div>
            <div className='simple-select-buttons-description-bc'>
{shuffledOptions.map(option => {
  let className = 'simple-Button-select-bc';

  if (isAnswerChecked) {
    if (option === currentQuestion.correctAnswer) {
      className = 'simple-Button-select-correct-bc';
    } else if (option === simpleSelectType) {
      className = 'simple-Button-select-incorrect-bc';
    }
  } else if (simpleSelectType === option) {
    className = 'simple-Button-select-colored-bc';
  }

  return (
    <button
      key={option}   // ✅ CHEIE STABILĂ → RANDOM OK
      className={className}
      disabled={isAnswerChecked}
      onClick={() => {
        setSimpleSelectType(option);
        buttonTextChange();
        setDesableButton(false);
      }}
    >
      <p>{option}</p>
    </button>
  );
})}


</div>


            
          </div>
          </div>
        );


case 'simpleApplication':
  return (
    <div className="quiz-content-scroll-bc">
      <div className="simple-application-container-bc">
        <div className="simple-application-instruction-bc">
          <div className="simple-application-content-bc">
            <div className="simple-application-context-bc">
              <p>{currentQuestion.context}</p>
            </div>
            <div className="simple-application-question-bc">
              <p>{currentQuestion.question}</p>
            </div>
            <div className="simple-application-buttons-bc">
              {shuffledApplicationOptions.map(option => (
                <div
                  key={option}
                  className={
                    isAnswerChecked
                      ? option === currentQuestion.correctAnswer
                        ? "simple-application-correct-bc"
                        : option === simpleSelectType
                        ? "simple-application-incorrect-bc"
                        : "simple-application-default-bc"
                      : simpleSelectType === option
                      ? "simple-application-selected-bc"
                      : "simple-application-default-bc"
                  }
                  onClick={() => {
                    if (isAnswerChecked) return;
                    setSimpleSelectType(option);
                    setDesableButton(false);
                    setTextButton("Verifica");
                    setChangeColorButton(true);
                  }}
                >
                  <b>{option}</b>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );


case 'decisionFlowApplication': {
  const step = currentQuestion.steps[decisionStepIndex];

  /* =========================
     ECRAN 1 – CONTEXT (doar afișare)
     ========================= */
  if (decisionPhase === 'intro') {
    return (
      <div className="simple-application-container-bc">
        <div className="simple-application-instruction-bc">
          <div className="simple-application-content-bc">






          <h2 className="motivational-title">
            Aplicatie practica
          </h2>

          <div className="simple-application-context-bc">
            <p style={{ whiteSpace: 'pre-line' }}>
              {currentQuestion.context}
            </p>
          </div>









 </div>
        </div>
      </div>
    );
  }

  /* =========================
     ECRAN FINAL – CONCLUZIE (doar afișare)
     ========================= */
  if (decisionPhase === 'final') {
    return (
      <div className="simple-application-container-bc">
        <div className="simple-application-instruction-bc">
          <div className="simple-application-content-bc">

          <h2 className="motivational-title">
            Aplicatie finalizata
          </h2>

         <div
  dangerouslySetInnerHTML={{
    __html: currentQuestion.finalMessage ||
      '<p>Aplicatie finalizata cu succes.</p>'
  }}
/>


          <p>
            <b>
              Scor: {currentQuestion.steps.length} / {currentQuestion.steps.length}
            </b> ⭐⭐⭐
          </p>

         </div>
         </div>
      </div>
    );
  }

  /* =========================
     PAȘII (quiz normal, fără butoane)
     ========================= */
  return (
    <div className="simple-application-container-bc">
        <div className="simple-application-instruction-bc">
          <div className="simple-application-content-bc">

        <div className="title-simple-select-align">
          <p className="practice-steps-bc">
             {decisionStepIndex + 1} / {currentQuestion.steps.length}
          </p>
        </div>

        <div className="simple-application-question-bc">
          <p>{step.question}</p>
        </div>

      



        <div className="simple-application-buttons-bc">
          
         {shuffledDecisionOptions.map(option => {
  let className = "simple-application-default-bc";

  if (isAnswerChecked) {
    if (option === step.correctAnswer) {
      className = "simple-application-correct-bc";
    } else if (option === decisionAnswer) {
      className = "simple-application-incorrect-bc";
    }
  } else if (decisionAnswer === option) {
    className = "simple-application-selected-bc";
  }

  return (
    <div
      key={option}   // ✅ CHEIE STABILĂ
      className={className}
      onClick={() => {
        if (isAnswerChecked) return;

        setDecisionAnswer(option);
        setDesableButton(false);
        setTextButton('Verifica');
        setChangeColorButton(true);
      }}
    >
      <b>{option}</b>
    </div>
  );
})}

        </div>

 <div className="practice-help-wrapper">
  <button
    className="practice-help-btn"
    onClick={() => setShowPracticeHelp(true)}
    title="Contextul aplicației"
  >
    <FontAwesomeIcon icon={faCircleInfo} />
  </button>
</div>


        </div>
      </div>
    </div>
  );
}



        case 'manualInput':
          return (
            <div className="quiz-content-scroll-bc">
            <div className='explanation-lesoon-container-bc'>
              <h4 className='tittle-sescrition-lesson'><strong>{currentQuestion.question}</strong></h4>
        
              <div className='align-input-items'>
                {currentQuestion.correctAnswer.map((answer, index) => {
                  const isCorrect = Number(userInput[index]) === answer.code; // Verifică dacă răspunsul este corect
                  const inputClass = isAnswerChecked
                    ? isCorrect
                      ? 'answer-input-correct'
                      : 'answer-input-incorrect'
                    : 'answer-input-item-complete';
        
                  return (
                    <div className='' key={index}>
                      <div className='input-item-answer-type'>
                        <input
                          className={inputClass}
                          type="number"
                          maxLength='4'
                          value={userInput[index] || ''}
                          onChange={(e) => { 
                            handleInputChange(index, e.target.value); 
                            setDesableButton(false);
                          }}
                          disabled={isAnswerChecked}
                        />
                        <p className='input-title-element-answer'>{answer.label}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            </div>
          );


          

case 'dragAndDropHorizontal': {
  const handleDragItemClick = (code) => {
    if (isAnswerChecked) return;

    // ❌ nu mai permitem mutarea dacă e deja folosit
    if (dataReceived.includes(code)) return;

    const emptyIndex = dataReceived.findIndex(
      v => v === null || v === undefined
    );

    if (emptyIndex !== -1) {
      setDataReceived(prev => {
        const updated = [...prev];
        updated[emptyIndex] = code;
        return updated;
      });
    }
  };

  const handleBoxClick = (slotIndex) => {
    if (isAnswerChecked) return;

    setDataReceived(prev => {
      const updated = [...prev];
      updated[slotIndex] = null;
      return updated;
    });
  };

  let slotCounter = -1;

  return (
    <div className="quiz-content-scroll-bc">
      <div className="explanation-lesoon-container-bc">

        <div className="title-simple-select-align">
          <p className="centred-simple-element">
            {currentQuestion.question}
          </p>
        </div>

        {/* PROPOZIȚIA */}
        <div className="horizontal-equation-layout-bc">
          {currentQuestion.correctAnswer.map((chunk, i) => {
            const isBlank = i % 2 === 1;

            if (!isBlank) {
              return (
                <span key={`txt-${i}`} className="equation-static-chunk">
                  {chunk}{' '}
                </span>
              );
            }

            slotCounter += 1;
            const slotIndex = slotCounter;
            const value = dataReceived[slotIndex] || '';

            return (
              <span
                key={`box-${slotIndex}`}
                className={`equation-box-bc ${
                  isAnswerChecked ? '' : 'cursor-pointer'
                }`}
                onClick={() => handleBoxClick(slotIndex)}
              >
                {value}
              </span>
            );
          })}
        </div>

        {/* OPȚIUNI */}
        {!isAnswerChecked && (
          <div className="horizontal-options-bc" style={{ marginBottom: '100px' }}>
           {shuffledDragHorizontalOptions.map(option => {

  const isUsed = dataReceived.includes(option.code);

  return (
    <button
      key={option.code}   // ✅ CHEIE STABILA → RANDOM OK
      className={`equation-option-btn-bc ${
        isUsed ? 'option-used-outline' : ''
      }`}
      onClick={() => handleDragItemClick(option.code)}
    >
      {option.code}
    </button>
  );
})}

          </div>
        )}

      </div>
    </div>
  );
}



         case 'dragAndDropOneAnswer': {
  const handleDragItemClick = (code) => {
    if (isAnswerChecked) return;
    if (dataReceived.includes(code)) return;

    setDataReceived([code]);
    setTextButton('Verifica');
  };

  const handleBoxClick = () => {
    if (isAnswerChecked) return;

    setDataReceived([]);
    setTextButton('Verifica');
  };

  return (
    <div className="quiz-content-scroll-bc">
      <div className="explanation-lesoon-container-bc">

        {/* Propoziția completabilă */}
        <div className="horizontal-equation-layout-bc">
          <p className="equation-box-static-bc">
            <span>{currentQuestion.correctAnswer[0]} </span>

            <span
              className={`equation-box-bc ${
                isAnswerChecked ? '' : 'cursor-pointer'
              }`}
              onClick={handleBoxClick}
            >
              {dataReceived[0] || ''}
            </span>

            <span> {currentQuestion.correctAnswer[2]}</span>
          </p>
        </div>

        {/* Opțiuni */}
        {!isAnswerChecked && (
          <div className="horizontal-options-bc">
          {shuffledDragOneOptions.map(option => {

  const isUsed = dataReceived.includes(option.code);

  return (
    <button
      key={option.code}   // ✅ CHEIE STABILĂ → RANDOM FUNCȚIONEAZĂ
      className={`equation-option-btn-bc ${
        isUsed ? 'placeholder-btn' : ''
      }`}
      onClick={() => handleDragItemClick(option.code)}
    >
      {option.code}
    </button>
  );
})}

          </div>
        )}

      </div>
    </div>
  );
}

   

          
          
          
          

        case 'multipleSelect':



          return (
            <div className="quiz-content-scroll-bc">
            <div className='explanation-lesoon-container-bc'>
              <div className='title-simple-select-align'>
                
              <div className="centred-simple-element">
               <span className="question-text-bc">{currentQuestion.question}</span>
              
              </div>  

                  </div>



               




              <div className='multiple-answer-lessons-bc'>
     {shuffledMultipleOptions.map(option => {

  const isSelected = selectedAnswers.includes(option);
  const isCorrect = currentQuestion.correctAnswer.includes(option);

  let checkboxClass = 'check-box-multiple-answer-bc';

  if (isAnswerChecked) {
    if (isCorrect) {
      checkboxClass = 'checkbox-correct';
    } else if (isSelected && !isCorrect) {
      checkboxClass = 'checkbox-incorrect';
    }
  }

  return (
    <div
      key={option}
      className={`align-multiple-items-bc ${
        isAnswerChecked
          ? isCorrect
            ? 'border-correct'
            : isSelected
            ? 'border-incorrect'
            : ''
          : isSelected
          ? 'border-selected'
          : ''
      }`}
      onClick={() => {
        if (isAnswerChecked) return;
        handleCheckboxChange(option);
      }}
    >
      <input
        className={checkboxClass}
        type="checkbox"
        checked={isSelected}
        readOnly
      />

      <span className="cursor-pointer">
        {option}
      </span>
    </div>
  );
})}


              </div>
            </div>
            </div>
          );

        case 'lessonResume':
  if (finalMessage) {
    return null;
  }

return (
  <div className='explanation-lesoon-container-resume-bc'>
    <div className="description-lesson-text-explanation-resume">
      
      <h2 className="motivational-title">{currentQuestion.titleExplanation}</h2>

      <div className='container-resume-lesson-bc'>
        {currentQuestion.descriptionExplanation.map((description, index) => (
          <div
            key={index}
            className="summary-info-line-bc"
            style={{ animationDelay: `${index * 0.3}s` }}
          >

            <div>
              <FontAwesomeIcon 
                icon={faCheckDouble} 
                className="summary-icon-resume-bc"
              />
            </div>

            <div
              className="text-size-emplanation-resume-bc"
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>

          </div>
        ))}
      </div>

{showRatingSection && (

<div className='feedback-resume-bc rating-appear'>
  <h3>Evaluezi lectia la:</h3>

  <div className="star-rating-container">
    {[1,2,3,4,5].map((star) => (
      <div className="star-wrapper" key={star}>
        <FontAwesomeIcon
          icon={faStar}
          className={`star-rating-item ${selectedRating >= star ? 'active' : ''}`}
          onClick={() => handleRating(star)}
        />

     
        
      </div>
    ))}
  </div>

  {/* Mesaj dinamic */}
{showRatingMessage && (
  <p
    key={"rating-msg-" + selectedRating}
    className={`rating-message ${showRatingMessage ? "show" : ""}`}
  >
    Multumim! 🤗
  </p>
)}




</div>

)}

    </div>
  </div>
);

case 'lessonCompletion':
  return (
    <div className='explanation-lesoon-container-resume-bc'>
      <div className="description-lesson-text-explanation-resume">

     

        {/* 🔥 GIF progres final peste tot */}
        <div className="lesson-progress-overlay">
          <img
            src={finallessonprogress}
            alt="Progres lectie"
            className="lesson-progress-overlay-image"
          />
        </div>

        {currentQuestion.descriptionExplanation.map((desc, index) => (
          <div
            key={index}
            className="text-size-emplanation-resume-bc"
            dangerouslySetInnerHTML={{ __html: desc }}
          />
        ))}

        {/* 🎉 Speech bubble cu mesaj de succes */}
        <div className="success-message-bubble bubble-slide-in-left">
          Felicitari!
        </div>

        <div className="lesson-image-container">
          <img
            src={final_congrats_conti}
            alt="Felicitari finale"
            className="lesson-image-finishandsend"
          />
        </div>

        {/* 🔥 Bara de progres - finalizare lectie */}
        <div className="lesson-completion-progress-wrapper">
          <p className="completion-progress-label">Lectie finalizata!</p>
          <div className="lesson-completion-progress-bar">
            <div
              className="lesson-completion-progress-fill"
              onAnimationEnd={() => setIsLessonCompletionBarDone(true)}
            ></div>
            
          </div>
        </div>

      </div>
    </div>
  );




          case 'JustInTimeMotivation':
  return (
   
      <div className='explanation-lesoon-container-resume-bc'>
      <div className="description-lesson-text-explanation-resume">
          {currentQuestion.descriptionExplanation.map((explanation, index) => (
            <div
              key={index}
              className="text-size-emplanation-bc"
              dangerouslySetInnerHTML={{ __html: explanation }}
            ></div>
          ))}
          
        <MotivationStats
  coins={lessonCoins}
  xp={lessonXp}
  correct={correctAnswersCount}
  wrong={wrongAnswersCount}
/>

    
        </div>
      </div>
    
  );

          
  case 'serieCompleta':
  return (
    
      <div className='explanation-lesoon-container-resume-bc'>
      <div className="description-lesson-text-explanation-resume">
          <h2 className="motivational-title">{currentQuestion.titleExplanation}</h2>
        
        
            <div className="lesson-image-container">
            <StreakDisplay />
            </div>
          
        </div>
      </div>
    
  );

  case 'deblocarePremium':
  return (
   
      <div className='explanation-lesoon-container-resume-bc'>
      <div className="description-lesson-text-explanation-resume">
          <h2 className="motivational-title">{currentQuestion.titleExplanation}</h2>
          
          
           <div className="lesson-image-container">

  {/* LISTA BENEFICII PREMIUM */}
  <div className="premium-benefits-box">
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Acces la lecțiile standard
    </div>
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Acces la lecțiile de practică
    </div>
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Acces la aplicații
    </div>
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Acces la testele de final de capitol
    </div>
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Certificat de finalizare a cursului
    </div>
  </div>

  {/* BUTOANE */}
  <div className="premium-buttons">
    <button className="premium-activate-btn">Activează acum</button>
    <button className="premium-remind-btn">Amintește-mi mai târziu</button>
  </div>

</div>

          
        </div>
      </div>
   
  );

  case 'clasament':
  return (
    <div className='explanation-lesoon-container-resume-bc'>
      <div className="description-lesson-text-explanation-resume">

        <h2 className="motivational-title">Clasament XP</h2>

        <Leaderboard />   {/* 🔥 Componenta nouă */}

      </div>
    </div>
  );



      default:
        return <p>Tipul întrebării nu este recunoscut.</p>;
    }

    

  };


  const currentQuestion = lessonData?.questions?.[nextQuestion];




// 🔹 DOAR pentru explanationLesson (UI logic)
const totalCards =
  currentQuestion?.type === 'explanationLesson'
    ? currentQuestion.descriptionExplanation.length
    : 0;


const currentExplanation = (() => {
  if (!currentQuestion) return null;

  if (currentQuestion.type === 'decisionFlowApplication') {
    return currentQuestion.steps?.[decisionStepIndex]?.explanation || null;
  }

  return currentQuestion.explanation || null;
})();

const isWaitingTopProgress =
  !isLessonFinished &&
  !noTransitionTypes.includes(currentType) &&
  (!isTopProgressReady || pendingLessonCompletionAdvance);

const contentTransitionKey =
  currentType === 'decisionFlowApplication'
    ? `${nextQuestion}-${decisionPhase}-${decisionStepIndex}`
    : `${nextQuestion}`;



  return (

 
    
    <div className='container-bc-general'>
  
      {/* Bara de progres */}
      <div className='position-progress-bar'>
        {!isLessonFinished && !showJumpHereIntro && (

         
        <StatusProgres 
  width={calculateProgress()}
  coinCount={coinCount}
  onExitClick={handleExitClick}
  onEyeClick={handleShowEyePopup}
  livesCount={lives}   
  lessonType={currentType}
  onProgressAnimationStateChange={setIsTopProgressReady}

/>

          
           
        )}




      </div>
  
      {/* Conținutul principal al lecției - păstrat vizibil indiferent de starea isLessonFinished */}


{showJumpHereIntro ? (
  <div className='position-main-lesson-bc'>
    <div className='jump-here-intro-container-bc'>
      <img
        src={Junphereconti}
        alt='Jump Here'
        className='jump-here-intro-image-bc'
      />
      <div className='jump-here-intro-actions-bc'>
        <button
          className='jump-here-intro-later-btn-bc'
          onClick={() => navigate('/functionalpagelogin')}
        >
          Poate mai tarziu
        </button>

        <button
          className='button-next-quizbc jump-here-intro-start-btn-bc'
          onClick={() => setShowJumpHereIntro(false)}
        >
          Incepe
        </button>
      </div>
    </div>
  </div>
) : noTransitionTypes.includes(currentType) ? (
  <div className='position-main-lesson-bc'>
    {renderContent()}
  </div>
) : (
  <SwitchTransition mode="out-in">
    <CSSTransition key={contentTransitionKey} timeout={300} classNames="fade">
      <div className='position-main-lesson-bc'>
        {renderContent()}
      </div>
    </CSSTransition>
  </SwitchTransition>
)}




  
      {/* Secțiunea butonului */}


  {!showJumpHereIntro && (
  <div className={`position-button-lesson-bc ${hideActionButton ? 'hide hide-border-top' : ''}`}>

        {showCorrectAnswer && (
          <p className='answer-show-after-button'>
            {isAnswerChecked && simpleCorrectAnswer}
          </p>
        )}
  
       


<div className={`button-group-navigationbc ${hideActionButton ? 'hide' : ''}`}>






<div className="lesson-navigation-row">

  {/* ✅ BUTON DOAR PENTRU explanationLesson */}



  
{/* Butonul care se schimbă între "Continuă" și "Finalizează lecția" */}
{currentQuestion?.type !== 'explanationLesson' && (
  (() => {
    const isWaitingLessonCompletionBar =
      isLessonFinished &&
      currentQuestion?.type === 'lessonCompletion' &&
      !isLessonCompletionBarDone;

    return (
  <button
    className={
      (desableButon || isWaitingLessonCompletionBar || isWaitingTopProgress)
        ? 'button-next-quizbc-desabled'
        : changeColorButton
        ? 'button-next-quizbc-verify'
        : 'button-next-quizbc'
    }
    disabled={desableButon || isWaitingLessonCompletionBar || isWaitingTopProgress}
onClick={() => {

  if (isWaitingTopProgress) {
    return;
  }

  // 🔥 1️⃣ FINAL LECȚIE – PRIMUL
  if (isLessonFinished) {
    if (isWaitingLessonCompletionBar) {
      return;
    }
    finalizeLesson();
    return;
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  // 2️⃣ TIPURI INFORMATIVE
  if (
  currentQuestion.type === 'JustInTimeMotivation' ||
  currentQuestion.type === 'serieCompleta' ||
  currentQuestion.type === 'deblocarePremium' ||
  currentQuestion.type === 'clasament'
)
 {
    toNextQuestion();
    setHideActionButton(false);
    return;
  }

  // 3️⃣ lessonCompletion
  if (
    currentQuestion.type === 'lessonCompletion' &&
  !lessonCompletionSentRef.current
  ) {
    sendLessonCompletion(currentQuestion.type);
    if (lessonXp > 0) sendLessonFinishXp(lessonXp);
    if (lessonCoins > 0) addCoins(lessonCoins);
    lessonCompletionSentRef.current = true;
    setDesableButton(true);
    toNextQuestion();
    return;
  }

  // 4️⃣ decisionFlowApplication
  if (currentQuestion.type === 'decisionFlowApplication') {
    if (decisionPhase === 'intro') {
      setDecisionPhase('steps');
      setDecisionAnswer(null);
      setIsAnswerChecked(false);
      setAnswerStatus(null);
      setDesableButton(true);
      setTextButton('Verifica');
      setChangeColorButton(false);
      setHideActionButton(false);
      return;
    }

    if (decisionPhase === 'final') {
      toNextQuestion();
      setHideActionButton(false);
      return;
    }

    if (decisionPhase === 'steps') {
      verifyAnswer();
      setHideActionButton(true);
      setShowFeedback(true);
      return;
    }

    return;
  }

  // 5️⃣ quiz normal
  if (isAnswerChecked) {
    toNextQuestion();
    setHideActionButton(false);
  } else {
    verifyAnswer();
    setHideActionButton(true);
    setShowFeedback(true);
  }
}}

  >
    {isLessonFinished && finalMessage
      ? 'urmatoarea lectie'
      : (textButton || 'Continua')}
  </button>
    );
  })()
)}


{currentQuestion?.type === 'explanationLesson' && (
  currentQuestion.descriptionExplanation && currentQuestion.descriptionExplanation.length === 1 ? (
    <button
      className="button-explanation-continue-single"
      onClick={() => {
        toNextQuestion();
        setHideActionButton(false);
      }}
    >
      Continua
    </button>
  ) : (
    <button
      className="button-explanation-continue-multi"
      onClick={() => {
        toNextQuestion();
        setHideActionButton(false);
      }}
    >
      Continua
    </button>
  )
)}

  {/* 🔹 BUTON CARDURI – DOAR PENTRU explanationLesson */}
{currentQuestion?.type === 'explanationLesson' && currentQuestion.descriptionExplanation && currentQuestion.descriptionExplanation.length > 1 && (
  <button
    className="button-next-card-bc"
    onClick={() => {
      const targetIndex = (cardIndex + 1) % totalCards;
      updateCardIndexWithSwipe(targetIndex);
    }}
  >
    <img src={changecard} alt="Schimbă cardul" className="change-card-gif-bc" />
  </button>
)}

     </div>
</div>


      </div>
      )}



  
      {/* Alerta de părăsire a lecției */}
   {showAlert && (
  <CustomAlert
    onConfirm={handleConfirmExit}
    onCancel={handleCancelExit}
  />
)}



{showFeedback && isAnswerChecked && (
  <FeedbackPopup
    status={answerStatus}
     messageCorrect={correctStreak === 5 ? "5 la rând!" : "Corect!"}
  xpAmount={correctStreak === 5 ? 30 : 10}   // 🔥 trimitem XP corect
  isStreakBonus={correctStreak === 5}
    message={message}
    chapterId={chapterId}
    lessonId={lessonId}
    questionIndex={nextQuestion}   // 🔥 cheia pentru comentarii pe fiecare întrebare
    onClose={handleHideFeedback}
    onContinue={() => {
 

  if (correctStreak === 5) {
    setCorrectStreak(0);
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  // 🔥 DACĂ SUNTEM ÎN decisionFlowApplication
if (currentQuestion.type === 'decisionFlowApplication') {
  handleHideFeedback();

  // după feedback -> pas următor / final
  if (decisionStepIndex < currentQuestion.steps.length - 1) {
    setDecisionStepIndex(prev => prev + 1);
    setDecisionAnswer(null);
    setIsAnswerChecked(false);
    setAnswerStatus(null);
    setDesableButton(true);
    setTextButton('Verifica');
    setChangeColorButton(false);
  } else {
    setDecisionPhase('final');
    setDecisionAnswer(null);
    setIsAnswerChecked(false);
    setAnswerStatus(null);
    setDesableButton(false);
    setTextButton('Continua');
    setChangeColorButton(false);
  }

  setHideActionButton(false);
  return;
}



  // 🔥 RESTUL QUIZURILOR
  toNextQuestion();
  setHideActionButton(false);
}}


    onShowAnswer={() => {
      setShowExplanationPopupModal(true);
      handleHideFeedback();
    }}
  />
)}



{showExplanationPopupModal && currentExplanation && (

  <ExplanationPopup
  explanation={currentExplanation}
  onContinue={() => {
    setShowExplanationPopupModal(false);

    const currentQuestion = lessonData.questions[nextQuestion];

    if (currentQuestion.type === 'decisionFlowApplication') {
      const steps = currentQuestion.steps;

      if (decisionStepIndex < steps.length - 1) {
        setDecisionStepIndex(prev => prev + 1);
        setDecisionAnswer(null);
        setIsAnswerChecked(false);
        setAnswerStatus(null);
        setDesableButton(true);
        setTextButton('Verifica');
        setChangeColorButton(false);
      } else {
        setDecisionPhase('final');
        setDecisionAnswer(null);
        setIsAnswerChecked(false);
        setAnswerStatus(null);
        setDesableButton(false);
        setTextButton('Continua');
        setChangeColorButton(false);
      }

      setHideActionButton(false);
      return;
    }

    // 🔥 restul quizurilor
    toNextQuestion();
    setHideActionButton(false);
  }}
/>

)}

{showNoLivesPopup && (
  <NoLivesPopup
    onClose={() => navigate('/functionalpagelogin')}
  />
)}


{showPracticeHelp && (
  <PracticeHelpPopup
    text={currentQuestion.context}
    onClose={() => setShowPracticeHelp(false)}
  />
)}





    </div>
  );
  



  
};



export default Chaptercontainer;